import { render, staticRenderFns } from "./SidebarNaf.vue?vue&type=template&id=77d88e3a"
import script from "./SidebarNaf.vue?vue&type=script&lang=js"
export * from "./SidebarNaf.vue?vue&type=script&lang=js"
import style0 from "./SidebarNaf.vue?vue&type=style&index=0&id=77d88e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports